import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Adminmoduleapi, usermoduleapi } from '../constants/api.constants';
import { HttpMethodService } from './httpMethod.service';
import { StorageService } from '../interceptor/storage.service';
import { environment } from '../../../environments/environment';
import { AllinoneService } from './allinone.service';
import { SocialAuthService } from '@abacritt/angularx-social-login';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpMethodService,  private userAuthService: StorageService, private allins: AllinoneService, private authService: SocialAuthService) {
   // //console.log(environment)
  }

  useremaillogin(data:any): Observable<any> {
    const headers = new HttpHeaders({
      'SkipInterceptor': 'true', // Skip the interceptor for login request
    });
    return this.http.loginpostMethod(`${Adminmoduleapi.serviceEndpoint}`,`${Adminmoduleapi.loginTokenApi}`,data, headers)
  }

  userforgotpwd(data:any, token:any): Observable<any> {
    const headers = new HttpHeaders({
      'admin-x-auth' : token,
      'SkipInterceptor': 'true', // Skip the interceptor for login request
    });
    return this.http.loginpostMethod(`${Adminmoduleapi.serviceEndpoint}`,`${usermoduleapi.restpwdbymail}`,data, headers)
  }

  userrestpwd(data:any, token:any): Observable<any> {
    const headers = new HttpHeaders({
      'admin-x-auth' : token,
      'SkipInterceptor': 'true', // Skip the interceptor for login request
    });
    return this.http.loginpostMethod(`${Adminmoduleapi.serviceEndpoint}`,`${usermoduleapi.resetpwdverifymail}`,data, headers)
  }

  userchangpwd(data:any, token:any): Observable<any> {
    const headers = new HttpHeaders({
      'x-auth' : token,
      'SkipInterceptor': 'true', // Skip the interceptor for login request
    });
    return this.http.loginpostMethod(`${Adminmoduleapi.serviceEndpoint}`,`${usermoduleapi.changepwd}`,data, headers)
  }

  userGoogle(data:any, token:any): Observable<any> {
    const headers = new HttpHeaders({
      'oAuth-token': environment.OuthToken,
      'SkipInterceptor': 'true', // Skip the interceptor for login request
    });
    return this.http.loginpostMethod(`${Adminmoduleapi.serviceEndpoint}`,`${Adminmoduleapi.loginTokenApi}`,data,  headers )
  }

  userRegister(data:any, token:any, driverown:any, outadmin:any): Observable<any> {
    const headers = new HttpHeaders({
      'user-role' : driverown,
      'oAuth-token': environment.OuthToken,
      'SkipInterceptor': 'true', // Skip the interceptor for login request
    });
    return this.http.loginpostMethod(`${Adminmoduleapi.serviceEndpoint}`,`${Adminmoduleapi.postadmins}`,data,headers)
  }

  userRegisterouth(data:any, token:any, driverown:any, outadmin:any): Observable<any> {
    const headers = new HttpHeaders({
      'oAuth-token': environment.OuthToken,
      'user-role' : driverown,
      'SkipInterceptor': 'true', // Skip the interceptor for login request
    });
    return this.http.loginOuthMethod(`${Adminmoduleapi.serviceEndpoint}`,`${usermoduleapi.loginouthApi}/${data.email}`, headers )
  }


  public roleMatch(allowedRoles: any): any {
    let isMatch = false;
    const userRoles: any = this.userAuthService.getRoles();

    if (userRoles != null && userRoles) {
      if (userRoles == allowedRoles) {
        isMatch = true;
        return isMatch;
      } else {
        return isMatch;
      }
    }
  }

  signouts() {
    this.signOut();
    sessionStorage.clear();
    this.userAuthService.setuseremail(null);
    this.userAuthService.clear();
    this.callMultiple();
  }

  callMultiple() {
    this.allins?.setdynamicmenu();
    this.allins?.setRoles();
    this.allins?.setToken();
    this.allins?.setUser();
  }

  signOut(): void {
    this.authService.signOut();
    return;
  }
}
